import { render } from "./PbSearchCard.vue?vue&type=template&id=0708eee0&scoped=true"
import script from "./PbSearchCard.vue?vue&type=script&lang=js"
export * from "./PbSearchCard.vue?vue&type=script&lang=js"

import "./PbSearchCard.vue?vue&type=style&index=0&id=0708eee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0708eee0"]])

export default __exports__